import { IconButton } from "@mui/material";
import { useMediaQuery, width } from "@mui/system";
import { useEffect, useState } from "react";
import styled from "styled-components";
import CloseIcon from "@mui/icons-material/Close";
import { useRecoilState } from "recoil";
import { HandleHelp } from "../atoms";

const HelpBox = styled.div`
  width: 100dvw;
  height: 100dvh;
  background-color: rgba(0, 0, 0, 0.8);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  z-index: 1001;
  position: fixed;
  top: 0;
  left: 0;
`;
const IconButtonStyle = styled(IconButton)`
  top: ${(props) => (props.$isMobile ? "10px" : "-60px")};
  svg {
    color: white;
    font-size: 25px;
  }
`;
function Help() {
  const [windowSize, setWindowSize] = useState({
    width: window.innerWidth,
    height: window.innerHeight,
  });
  const isMobile = useMediaQuery("(max-width: 768px)");
  const [showHelp, setShowHelp] = useRecoilState(HandleHelp);

  useEffect(() => {
    const handleWindowSize = () => {
      const width = window.innerWidth;
      const height = window.innerHeight;
      setWindowSize({ width, height });
    };

    window.addEventListener("resize", handleWindowSize);
    return () => window.removeEventListener("resize", handleWindowSize);
  }, [windowSize]);
  return (
    <>
      <HelpBox>
        {isMobile ? (
          <img
            src="https://webfile.mempro.co.kr/catalog/help/mobile_help.png"
            height={windowSize.height / 1.5}
          />
        ) : (
          <img
            src="https://webfile.mempro.co.kr/catalog/help/help.png"
            height={windowSize.height / 1.8}
          />
        )}

        <IconButtonStyle
          onClick={() => setShowHelp((prev) => !prev)}
          $isMobile={isMobile}
        >
          <CloseIcon />
        </IconButtonStyle>
      </HelpBox>
    </>
  );
}

export default Help;
